import { Link } from "react-router-dom";

export const About = () => {
  return (
    <div className="min-h-screen bg-[#050505]" data-testid="about-page">
      {/* Hero Section - Full Width with Parallax Effect */}
      <section className="relative min-h-[70vh] flex items-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src="https://customer-assets.emergentagent.com/job_goldnote-portal/artifacts/mmafn7da_1%20Gram%20100%20pc%20Laser%20Tray%20with%20Fiches.jpeg"
            alt="Goldnote Manufacturing"
            className="w-full h-full object-cover opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#050505]/80 to-[#050505]" />
        </div>
        
        <div className="relative container mx-auto px-6 lg:px-12 py-20">
          <div className="max-w-4xl">
            <p className="text-[0.7rem] tracking-[0.4em] uppercase text-[#D4AF37] mb-6 animate-fade-in">
              100 Yellow Brick Road, Niagara Falls, Ontario
            </p>
            <h1 className="text-5xl md:text-6xl lg:text-7xl leading-[1.05] mb-8 animate-fade-in-up" style={{ fontFamily: 'Cinzel, serif' }}>
              <span className="text-white/90">Gold You Can</span>
              <br />
              <span className="gold-gradient">Carry In Your Wallet</span>
            </h1>
            <p className="text-lg md:text-xl text-white/80 font-light leading-relaxed max-w-2xl animate-fade-in-up-delay-1">
              Goldnote is a unique precious metals investment product comprised of 
              99.99% pure gold within a polymer banknote. Our patented technology 
              makes it easy to carry real gold in your wallet.
            </p>
          </div>
        </div>
        
        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
          <span className="text-[0.6rem] tracking-widest uppercase text-white/30">Scroll</span>
          <div className="w-[1px] h-8 bg-gradient-to-b from-[#D4AF37]/50 to-transparent" />
        </div>
      </section>

      {/* The Innovation Section */}
      <section className="py-24 md:py-32">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
            <div>
              <p className="text-[0.65rem] tracking-[0.4em] uppercase text-[#D4AF37]/80 mb-4">
                The Innovation
              </p>
              <h2 className="text-3xl md:text-4xl lg:text-5xl text-white/90 mb-8 leading-tight" style={{ fontFamily: 'Cinzel, serif' }}>
                A Proprietary <br/>
                <span className="gold-gradient">Monetary Note</span>
              </h2>
              <div className="space-y-6 text-white/70 font-light leading-relaxed">
                <p>
                  Goldnote is a proprietary monetary note containing an embedded gold fiche 
                  within a clear polymer window. Each gold fiche contains markings that 
                  signify its weight, its 9999 purity, and both our hallmark logo and 
                  registered trademark name.
                </p>
                <p>
                  The surrounding note states the weight of the gold fiche and contains 
                  numerous security features, in particular the secure QR code with which 
                  the note can be authenticated using a smartphone.
                </p>
              </div>
              
              {/* Patent Badges */}
              <div className="flex flex-wrap gap-3 mt-10">
                <div className="px-4 py-2 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded">
                  <span className="text-[0.65rem] tracking-wider text-[#D4AF37]">U.S. Patent 10,668,765 B2</span>
                </div>
                <div className="px-4 py-2 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded">
                  <span className="text-[0.65rem] tracking-wider text-[#D4AF37]">Canadian Patent 3,097,803</span>
                </div>
                <div className="px-4 py-2 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded">
                  <span className="text-[0.65rem] tracking-wider text-[#D4AF37]">Indian Patent 519472</span>
                </div>
              </div>
              <p className="text-[0.6rem] text-white/30 mt-3 tracking-wider">
                Patents pending: European Union, People's Republic of China
              </p>
            </div>
            
            {/* Image Grid */}
            <div className="relative">
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-4">
                  <div className="aspect-square bg-[#0A0A0A] border border-white/5 rounded-lg overflow-hidden">
                    <img 
                      src="/1g-goldnote-obverse.png" 
                      alt="Goldnote Obverse"
                      className="w-full h-full object-contain p-6 hover:scale-110 transition-transform duration-700"
                    />
                  </div>
                  <div className="aspect-[4/3] bg-[#0A0A0A] border border-white/5 rounded-lg overflow-hidden">
                    <img 
                      src="/1g-double-eagle-reverse-new.png" 
                      alt="Goldnote Reverse"
                      className="w-full h-full object-contain p-4 hover:scale-110 transition-transform duration-700"
                    />
                  </div>
                </div>
                <div className="space-y-4 mt-8">
                  <div className="aspect-[4/3] bg-[#0A0A0A] border border-white/5 rounded-lg overflow-hidden">
                    <img 
                      src="/canada-forever-obverse.png" 
                      alt="Canada Forever"
                      className="w-full h-full object-contain p-4 hover:scale-110 transition-transform duration-700"
                    />
                  </div>
                  <div className="aspect-square bg-[#0A0A0A] border border-white/5 rounded-lg overflow-hidden">
                    <img 
                      src="/electrum-obverse.png" 
                      alt="Electrum"
                      className="w-full h-full object-contain p-6 hover:scale-110 transition-transform duration-700"
                    />
                  </div>
                </div>
              </div>
              {/* Decorative Element */}
              <div className="absolute -bottom-6 -left-6 w-32 h-32 border border-[#D4AF37]/20 rounded-lg -z-10" />
            </div>
          </div>
        </div>
      </section>

      {/* Available Denominations */}
      <section className="py-20 bg-[#0A0A0A] border-y border-white/5">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <p className="text-[0.65rem] tracking-[0.4em] uppercase text-[#D4AF37]/80 mb-4">
              Available Sizes
            </p>
            <h2 className="text-3xl md:text-4xl text-white/90" style={{ fontFamily: 'Cinzel, serif' }}>
              Denominations
            </h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-6 md:gap-8">
            <div className="text-center p-6 border border-white/5 rounded-xl hover:border-[#D4AF37]/30 transition-colors">
              <p className="text-3xl md:text-4xl font-light gold-gradient mb-2" style={{ fontFamily: 'Cinzel, serif' }}>1g</p>
              <p className="text-[0.65rem] tracking-[0.15em] uppercase text-white/40">Available Now</p>
            </div>
            <div className="text-center p-6 border border-white/5 rounded-xl opacity-60">
              <p className="text-3xl md:text-4xl font-light text-white/70 mb-2" style={{ fontFamily: 'Cinzel, serif' }}>5g</p>
              <p className="text-[0.65rem] tracking-[0.15em] uppercase text-white/30">Coming Soon</p>
            </div>
            <div className="text-center p-6 border border-white/5 rounded-xl opacity-60">
              <p className="text-3xl md:text-4xl font-light text-white/70 mb-2" style={{ fontFamily: 'Cinzel, serif' }}>10g</p>
              <p className="text-[0.65rem] tracking-[0.15em] uppercase text-white/30">Coming Soon</p>
            </div>
            <div className="text-center p-6 border border-white/5 rounded-xl opacity-60">
              <p className="text-3xl md:text-4xl font-light text-white/70 mb-2" style={{ fontFamily: 'Cinzel, serif' }}>1/10 oz</p>
              <p className="text-[0.65rem] tracking-[0.15em] uppercase text-white/30">Coming Soon</p>
            </div>
            <div className="text-center p-6 border border-white/5 rounded-xl opacity-60">
              <p className="text-3xl md:text-4xl font-light text-white/70 mb-2" style={{ fontFamily: 'Cinzel, serif' }}>1/4 oz</p>
              <p className="text-[0.65rem] tracking-[0.15em] uppercase text-white/30">Coming Soon</p>
            </div>
          </div>
        </div>
      </section>

      {/* State of the Art Features */}
      <section className="py-24 md:py-32">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="text-center mb-20">
            <p className="text-[0.65rem] tracking-[0.4em] uppercase text-[#D4AF37]/80 mb-4">
              State of the Art
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl text-white/90" style={{ fontFamily: 'Cinzel, serif' }}>
              Note Design
            </h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
            {/* Card 1 */}
            <div className="group p-10 bg-gradient-to-b from-[#0A0A0A] to-[#050505] border border-white/5 hover:border-[#D4AF37]/40 rounded-2xl transition-all duration-500">
              <div className="w-16 h-16 mb-8 border border-[#D4AF37]/30 rounded-xl flex items-center justify-center group-hover:bg-[#D4AF37]/10 transition-colors duration-500">
                <svg className="w-7 h-7 text-[#D4AF37]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-xl text-white/90 mb-4" style={{ fontFamily: 'Cinzel, serif' }}>Anti-Counterfeit Technology</h3>
              <p className="text-sm text-white/70 font-light leading-relaxed">
                Numerous embedded security features protect each Goldnote from counterfeiting, 
                ensuring the authenticity and value of your investment.
              </p>
            </div>

            {/* Card 2 */}
            <div className="group p-10 bg-gradient-to-b from-[#0A0A0A] to-[#050505] border border-white/5 hover:border-[#D4AF37]/40 rounded-2xl transition-all duration-500">
              <div className="w-16 h-16 mb-8 border border-[#D4AF37]/30 rounded-xl flex items-center justify-center group-hover:bg-[#D4AF37]/10 transition-colors duration-500">
                <svg className="w-7 h-7 text-[#D4AF37]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                </svg>
              </div>
              <h3 className="text-xl text-white/90 mb-4" style={{ fontFamily: 'Cinzel, serif' }}>Tangible Asset</h3>
              <p className="text-sm text-white/70 font-light leading-relaxed">
                A tangible asset that possesses intrinsic value—not dependent on any counterparty. 
                Real gold you can hold, store, and transport with ease.
              </p>
            </div>

            {/* Card 3 */}
            <div className="group p-10 bg-gradient-to-b from-[#0A0A0A] to-[#050505] border border-white/5 hover:border-[#D4AF37]/40 rounded-2xl transition-all duration-500">
              <div className="w-16 h-16 mb-8 border border-[#D4AF37]/30 rounded-xl flex items-center justify-center group-hover:bg-[#D4AF37]/10 transition-colors duration-500">
                <svg className="w-7 h-7 text-[#D4AF37]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
                </svg>
              </div>
              <h3 className="text-xl text-white/90 mb-4" style={{ fontFamily: 'Cinzel, serif' }}>Sleek Design</h3>
              <p className="text-sm text-white/70 font-light leading-relaxed">
                A sleek design aesthetic that is both easily stored and transported. 
                Fits right in your wallet alongside your everyday cards.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* QR Authentication Section */}
      <section className="py-24 md:py-32 bg-[#0A0A0A]">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="order-2 lg:order-1">
              <div className="aspect-video bg-[#050505] border border-white/5 rounded-2xl overflow-hidden flex items-center justify-center">
                <div className="text-center p-8">
                  <div className="w-32 h-32 mx-auto mb-6 border-2 border-[#D4AF37]/30 rounded-2xl flex items-center justify-center">
                    <svg className="w-16 h-16 text-[#D4AF37]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" />
                    </svg>
                  </div>
                  <p className="text-white/40 text-sm">Secure QR Code Authentication</p>
                </div>
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <p className="text-[0.65rem] tracking-[0.4em] uppercase text-[#D4AF37]/80 mb-4">
                Instant Verification
              </p>
              <h2 className="text-3xl md:text-4xl lg:text-5xl text-white/90 mb-8 leading-tight" style={{ fontFamily: 'Cinzel, serif' }}>
                Authentication by <br/>
                <span className="gold-gradient">Secure QR Code</span>
              </h2>
              <div className="space-y-6 text-white/70 font-light leading-relaxed">
                <p>
                  Goldnote's Secure QR code is a smartphone-readable encrypted code 
                  supporting rapid and secure authentication. Simply scan the QR code 
                  on your Goldnote to instantly verify its authenticity.
                </p>
                <p>
                  Our proprietary authentication system ensures that every Goldnote 
                  can be verified anywhere in the world, giving you complete confidence 
                  in your investment.
                </p>
              </div>
              <a 
                href="https://www.goldnote.gold/authentication.html"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 mt-8 px-6 py-3 border border-[#D4AF37]/50 text-[#D4AF37] hover:bg-[#D4AF37]/10 text-sm tracking-[0.15em] uppercase rounded-lg transition-colors"
              >
                <span>Watch QR Video</span>
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Exclusive Retail Partners */}
      <section className="py-20 border-t border-white/5">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <p className="text-[0.65rem] tracking-[0.4em] uppercase text-[#D4AF37]/80 mb-4">
              Exclusive Retailers
            </p>
            <h2 className="text-3xl md:text-4xl text-white/90" style={{ fontFamily: 'Cinzel, serif' }}>
              Where To Buy
            </h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {/* JM Bullion - USA */}
            <div className="p-8 bg-[#0A0A0A] border border-white/5 rounded-2xl text-center hover:border-[#D4AF37]/30 transition-colors">
              <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-[#D4AF37]/10 flex items-center justify-center">
                <img 
                  src="https://flagcdn.com/w80/us.png" 
                  alt="USA" 
                  className="w-8 h-5 object-cover rounded-sm"
                />
              </div>
              <h3 className="text-xl text-white/90 mb-2" style={{ fontFamily: 'Cinzel, serif' }}>JM Bullion</h3>
              <p className="text-[0.65rem] tracking-[0.2em] uppercase text-[#D4AF37] mb-4">Exclusive U.S. Retailer</p>
              <p className="text-sm text-white/70 font-light leading-relaxed mb-6">
                JM Bullion is Goldnote's exclusive U.S. retailer. Look for an expanding 
                portfolio of denominations and special collector's edition notes.
              </p>
              <a 
                href="https://www.jmbullion.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 bg-[#D4AF37] text-[#050505] hover:bg-[#EEDC9A] text-xs tracking-[0.15em] uppercase font-medium rounded-lg transition-colors"
              >
                <span>Shop JM Bullion</span>
                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </a>
            </div>
            
            {/* TD Precious Metals - Canada */}
            <div className="p-8 bg-[#0A0A0A] border border-white/5 rounded-2xl text-center hover:border-[#D4AF37]/30 transition-colors">
              <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-[#D4AF37]/10 flex items-center justify-center">
                <img 
                  src="https://flagcdn.com/w80/ca.png" 
                  alt="Canada" 
                  className="w-8 h-5 object-cover rounded-sm"
                />
              </div>
              <h3 className="text-xl text-white/90 mb-2" style={{ fontFamily: 'Cinzel, serif' }}>TD Precious Metals</h3>
              <p className="text-[0.65rem] tracking-[0.2em] uppercase text-[#D4AF37] mb-4">Exclusive Canada Retailer</p>
              <p className="text-sm text-white/70 font-light leading-relaxed mb-6">
                TD Precious Metals is Goldnote's exclusive Canadian retailer. 
                Buy and sell gold online or at TD branches across Canada.
              </p>
              <a 
                href="https://preciousmetals.td.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 bg-[#D4AF37] text-[#050505] hover:bg-[#EEDC9A] text-xs tracking-[0.15em] uppercase font-medium rounded-lg transition-colors"
              >
                <span>Shop TD Metals</span>
                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Custom Goldnotes */}
      <section className="py-24 md:py-32 bg-[#0A0A0A]">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <p className="text-[0.65rem] tracking-[0.4em] uppercase text-[#D4AF37]/80 mb-4">
                For Business
              </p>
              <h2 className="text-3xl md:text-4xl lg:text-5xl text-white/90 mb-8 leading-tight" style={{ fontFamily: 'Cinzel, serif' }}>
                Custom <span className="gold-gradient">Goldnotes</span>
              </h2>
              <div className="space-y-6 text-white/70 font-light leading-relaxed">
                <p>
                  Create your own branded Goldnotes for corporate gifts, special events, 
                  commemorative editions, or promotional campaigns. Our custom program 
                  allows you to feature your logo, artwork, or design on genuine Goldnotes.
                </p>
                <p>
                  Perfect for employee recognition, client appreciation, milestone celebrations, 
                  and premium corporate gifting. Contact us to discuss your custom Goldnote vision.
                </p>
              </div>
              <div className="flex flex-wrap gap-3 mt-8">
                <div className="px-4 py-2 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded">
                  <span className="text-[0.65rem] tracking-wider text-[#D4AF37]">Co-Branded Issues</span>
                </div>
                <div className="px-4 py-2 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded">
                  <span className="text-[0.65rem] tracking-wider text-[#D4AF37]">Corporate Gifts</span>
                </div>
                <div className="px-4 py-2 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded">
                  <span className="text-[0.65rem] tracking-wider text-[#D4AF37]">Sovereign Issues</span>
                </div>
              </div>
              <Link 
                to="/corporate"
                className="inline-flex items-center gap-3 mt-8 px-6 py-3 border border-[#D4AF37]/50 text-[#D4AF37] hover:bg-[#D4AF37]/10 text-sm tracking-[0.15em] uppercase rounded-lg transition-colors"
              >
                <span>Request Custom Quote</span>
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </Link>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="aspect-square bg-[#050505] border border-white/5 rounded-xl overflow-hidden">
                <img 
                  src="/amherst-obverse.png" 
                  alt="Amherst Custom Goldnote"
                  className="w-full h-full object-contain p-4 hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="aspect-square bg-[#050505] border border-white/5 rounded-xl overflow-hidden mt-8">
                <img 
                  src="/amherst-reverse.png" 
                  alt="Amherst Custom Goldnote Reverse"
                  className="w-full h-full object-contain p-4 hover:scale-105 transition-transform duration-500"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Info */}
      <section className="py-20 border-t border-white/5">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center">
            <div>
              <div className="w-12 h-12 mx-auto mb-4 border border-[#D4AF37]/30 rounded-xl flex items-center justify-center">
                <svg className="w-5 h-5 text-[#D4AF37]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h3 className="text-lg text-white/90 mb-2" style={{ fontFamily: 'Cinzel, serif' }}>Location</h3>
              <p className="text-sm text-white/70">100 Yellow Brick Road<br/>Niagara Falls, Ontario</p>
            </div>
            <div>
              <div className="w-12 h-12 mx-auto mb-4 border border-[#D4AF37]/30 rounded-xl flex items-center justify-center">
                <svg className="w-5 h-5 text-[#D4AF37]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-lg text-white/90 mb-2" style={{ fontFamily: 'Cinzel, serif' }}>Email</h3>
              <a href="mailto:gold@goldnote.gold" className="text-sm text-[#D4AF37] hover:text-[#EEDC9A] transition-colors">
                gold@goldnote.gold
              </a>
            </div>
            <div>
              <div className="w-12 h-12 mx-auto mb-4 border border-[#D4AF37]/30 rounded-xl flex items-center justify-center">
                <svg className="w-5 h-5 text-[#D4AF37]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </div>
              <h3 className="text-lg text-white/90 mb-2" style={{ fontFamily: 'Cinzel, serif' }}>Toll Free</h3>
              <a href="tel:1-855-558-4653" className="text-sm text-[#D4AF37] hover:text-[#EEDC9A] transition-colors">
                1-855-558-GOLD (4653)
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 md:py-32 relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0" style={{ 
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23D4AF37' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }} />
        </div>
        
        <div className="relative container mx-auto px-6 lg:px-12">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl lg:text-5xl text-white/90 mb-6" style={{ fontFamily: 'Cinzel, serif' }}>
              Ready to Own <span className="gold-gradient">Real Gold</span>?
            </h2>
            <p className="text-lg text-white/70 font-light mb-10">
              Explore our collection and discover why Goldnote is the future of portable gold ownership.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/products"
                className="px-10 py-4 bg-[#D4AF37] text-[#050505] hover:bg-[#EEDC9A] text-sm tracking-[0.2em] uppercase font-medium rounded-lg transition-colors"
              >
                View Products
              </Link>
              <Link 
                to="/contact"
                className="px-10 py-4 border border-[#D4AF37]/50 text-[#D4AF37] hover:bg-[#D4AF37]/10 text-sm tracking-[0.2em] uppercase font-medium rounded-lg transition-colors"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
